export const EQUIPMENT_TYPE_VEHICLE = 'vehicles';
export const EQUIPMENT_TYPE_CHARGER = 'chargers';
